import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'
import {organizationSchema} from "./schema";

export const courseEnrollmentSchema = new schema.Entity(
    'courses',
    {},
    {
        idAttribute: 'id',
    }
)

export const courseEnrollment_getById_Api = {
    name: 'courseEnrollment_getById_Api',
    backend: `Route::get('courses/course-enrollment/{id}/get', 'CourseEnrollmentController@getById');`,
    root: API_ROOT_URL,
    path: '/courses/course-enrollment/:id/get',
    method: 'GET',
    schema: courseEnrollmentSchema,
    transform: createTransform(courseEnrollmentSchema, 'data'),
}

export const course_registerForCourse_Api = {
    name: 'course_registerForCourse_Api',
    backend: `Route::post('courses/course/{id}/course-enrollment/register', 'CourseEnrollmentController@registerForCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/course-enrollment/register',
    method: 'POST',
    schema: courseEnrollmentSchema,
    transform: createTransform(courseEnrollmentSchema, 'data'),
}

export const course_getCourseEnrollments_Api = {
    name: 'course_getCourseEnrollments_Api',
    backend: `Route::get('courses/course/{id}/course-enrollment/gets', 'CourseEnrollmentController@getCourseEnrollments');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/course-enrollment/gets',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status'],
    schema: courseEnrollmentSchema,
    transform: createListTransform(courseEnrollmentSchema),
}

export const course_getCourseEnrollmentsByOwner_Api = {
    name: 'course_getCourseEnrollmentsByOwner_Api',
    backend: `Route::get('courses/course-enrollment/{type}/{id}/gets', 'CourseEnrollmentController@getCourseEnrollmentsByOwner');`,
    root: API_ROOT_URL,
    path: '/courses/course-enrollment/:type/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status', 'course_id'],
    schema: courseEnrollmentSchema,
    transform: createListTransform(courseEnrollmentSchema),
}

export const course_manageCourseEnrollmentAccept_Api = {
    name: 'course_manageCourseEnrollmentAccept_Api',
    backend: `Route::post('courses/course-enrollment/{id}/manage-accept', 'CourseEnrollmentController@manageCourseEnrollmentAccept');`,
    root: API_ROOT_URL,
    path: '/courses/course-enrollment/:id/manage-accept',
    method: 'POST',
    schema: courseEnrollmentSchema,
    transform: createTransform(courseEnrollmentSchema, 'data'),
}

export const course_manageCourseEnrollmentReject_Api = {
    name: 'course_manageCourseEnrollmentReject_Api',
    backend: `Route::post('courses/course-enrollment/{id}/manage-reject', 'CourseEnrollmentController@manageCourseEnrollmentReject');`,
    root: API_ROOT_URL,
    path: '/courses/course-enrollment/:id/manage-reject',
    method: 'POST',
    schema: courseEnrollmentSchema,
    transform: createTransform(courseEnrollmentSchema, 'data'),
}

export const course_deleteCourseEnrollment_Api = {
    name: 'course_deleteCourseEnrollment_Api',
    backend: `Route::post('courses/course-enrollment/{id}/delete', 'CourseEnrollmentController@deleteCourseEnrollment');`,
    root: API_ROOT_URL,
    path: '/courses/course-enrollment/:id/delete',
    method: 'POST',
    schema: courseEnrollmentSchema,
    transform: createTransform(courseEnrollmentSchema, 'data'),
}

export const course_createCourseEnrollment_Api = {
    name: 'course_createCourseEnrollment_Api',
    backend: `Route::post('courses/course/{id}/course-enrollment/create', 'CourseEnrollmentController@createCourseEnrollment');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/course-enrollment/create',
    method: 'POST',
    schema: courseEnrollmentSchema,
    transform: createTransform(courseEnrollmentSchema, 'data'),
}

//  ===================================== course =====================================
export const courseSchema = new schema.Entity(
    'courses',
    {},
    {
        idAttribute: 'idname',
    }
)

export const course_getCourses_Api = {
    name: 'course_getCourses_Api',
    backend: `Route::get('courses/course/{type}/{id}/gets', 'CourseController@getCourses');`,
    root: API_ROOT_URL,
    path: '/courses/course/:type/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'status','status_text', 'valid', 'academic_year', 'academic_field', 'filter'],
    schema: courseSchema,
    transform: createListTransform(courseSchema),
}

export const course_createCourse_Api = {
    name: 'course_createCourse_Api',
    backend: `Route::post('courses/{type}/{id}/course/create', 'CourseController@createCourse');`,
    root: API_ROOT_URL,
    path: '/courses/:type/:id/course/create',
    method: 'POST',
    schema: courseSchema,
    transform: createTransform(courseSchema, 'data'),
}

export const course_deleteCourse_Api = {
    name: 'course_deleteCourse_Api',
    backend: `Route::post('courses/course/{id}/delete', 'CourseController@deleteCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/delete',
    method: 'POST',
    schema: courseSchema,
    transform: createTransform(courseSchema, 'data'),
}

export const course_editCourse_Api = {
    name: 'course_editCourse_Api',
    backend: `Route::post('courses/course/{id}/edit', 'CourseController@editCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/edit',
    method: 'POST',
    schema: courseSchema,
    transform: createTransform(courseSchema, 'data'),
}

export const course_copyCourse_Api = {
    name: 'course_editCourse_Api',
    backend: `Route::post('courses/course/{id}/duplicate', 'CourseController@copyCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/duplicate',
    method: 'POST',
    schema: courseSchema,
    transform: createTransform(courseSchema, 'data'),
}

export const course_promoteStudents_Api = {
    name: 'course_promoteStudents_Api',
    root: API_ROOT_URL,
    path: '/courses/course/:id/promote-students',
    method: 'POST',
}

export const course_promotePreview_Api = {
    name: 'course_promotePreview_Api',
    root: API_ROOT_URL,
    path: '/courses/course/:id/promote-preview',
    method: 'GET',
    paramsFields: ['source_course_id'],
}

export const course_getCourseById_Api = {
    name: 'course_getCourseById_Api',
    backend: `Route::get('courses/course/{id}/get', 'CourseController@getById');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/get',
    method: 'GET',
    schema: courseSchema,
    transform: createTransform(courseSchema, 'data'),
}

//  ===================================== Teacher =====================================
export const teacherSchema = new schema.Entity(
    'teacher',
    {},
    {
        idAttribute: 'id',
    }
)

export const course_getTeachers_Api = {
    name: 'course_getTeachers_Api',
    backend: `Route::get('courses/teacher/{type}/{id}/gets', 'TeacherController@getTeachers');`,
    root: API_ROOT_URL,
    path: '/courses/teacher/:type/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'includes', 'hashtags'],
    schema: teacherSchema,
    transform: createListTransform(teacherSchema),
}

export const course_createTeacher_Api = {
    name: 'course_createTeacher_Api',
    backend: `Route::post('courses/{type}/{id}/teacher/create', 'TeacherController@createTeacher');`,
    root: API_ROOT_URL,
    path: '/courses/:type/:id/teacher/create',
    method: 'POST',
    schema: teacherSchema,
    transform: createTransform(teacherSchema, 'data'),
}

export const course_deleteTeacher_Api = {
    name: 'course_deleteTeacher_Api',
    backend: `Route::post('courses/teacher/{id}/delete', 'TeacherController@deleteTeacher');`,
    root: API_ROOT_URL,
    path: '/courses/teacher/:id/delete',
    method: 'POST',
    schema: teacherSchema,
    transform: createTransform(teacherSchema, 'data'),
}

export const course_editTeacher_Api = {
    name: 'course_editTeacher_Api',
    backend: `Route::post('courses/teacher/{id}/edit', 'TeacherController@editTeacher');`,
    root: API_ROOT_URL,
    path: '/courses/teacher/:id/edit',
    method: 'POST',
    schema: teacherSchema,
    transform: createTransform(teacherSchema, 'data'),
}

export const course_getTeacherById_Api = {
    name: 'course_getTeacherById_Api',
    backend: `Route::get('courses/teacher/{id}/get', 'TeacherController@getById');`,
    root: API_ROOT_URL,
    path: '/courses/teacher/:id/get',
    method: 'GET',
    schema: teacherSchema,
    transform: createTransform(teacherSchema, 'data'),
}

// =====================================  Student =====================================
export const studentSchema = new schema.Entity(
    'students',
    {},
    {
        idAttribute: 'id',
    }
)

export const course_getStudents_Api = {
    name: 'course_getStudents_Api',
    backend: `Route::get('courses/student/{type}/{id}/gets', 'StudentController@getStudents');`,
    root: API_ROOT_URL,
    path: '/courses/student/:type/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'email', 'identifier_code', 'student_idcode', 'sort-by', 'course_id', 'course_class_id', 'sub_class_name', 'with_ids', 'identity_status', 'include_archived'],
    schema: studentSchema,
    transform: createListTransform(studentSchema),
}

export const course_createStudent_Api = {
    name: 'course_createStudent_Api',
    backend: `Route::post('courses/{type}/{id}/student/create', 'StudentController@createStudent');`,
    root: API_ROOT_URL,
    path: '/courses/:type/:id/student/create',
    method: 'POST',
    schema: studentSchema,
    transform: createTransform(studentSchema, 'data'),
}

export const course_deleteStudent_Api = {
    name: 'course_deleteStudent_Api',
    backend: `Route::post('courses/student/{id}/delete', 'StudentController@deleteStudent');`,
    root: API_ROOT_URL,
    path: '/courses/student/:id/delete',
    method: 'POST',
    schema: studentSchema,
    transform: createTransform(studentSchema, 'data'),
}

export const course_editStudent_Api = {
    name: 'course_editStudent_Api',
    backend: `Route::post('courses/student/{id}/edit', 'StudentController@editStudent');`,
    root: API_ROOT_URL,
    path: '/courses/student/:id/edit',
    method: 'POST',
    schema: studentSchema,
    transform: createTransform(studentSchema, 'data'),
}

export const course_getStudentById_Api = {
    name: 'course_getStudentById_Api',
    backend: `Route::get('courses/student/{id}/get', 'StudentController@getById');`,
    root: API_ROOT_URL,
    path: '/courses/student/:id/get',
    method: 'GET',
    schema: studentSchema,
    transform: createTransform(studentSchema, 'data'),
}

// =====================================  Student — Duplicate Detection =====================================

export const course_scanDuplicates_Api = {
  name: 'course_scanDuplicates_Api',
  backend: `Route::post('courses/{type}/{id}/students/scan-duplicates', 'StudentMergeController@scanDuplicates');`,
  root: API_ROOT_URL,
  path: '/courses/:type/:id/students/scan-duplicates',
  method: 'POST',
}

export const course_getDuplicates_Api = {
  name: 'course_getDuplicates_Api',
  backend: `Route::get('courses/{type}/{id}/students/duplicates', 'StudentMergeController@getDuplicates');`,
  root: API_ROOT_URL,
  path: '/courses/:type/:id/students/duplicates',
  method: 'GET',
}

export const course_dismissDuplicate_Api = {
  name: 'course_dismissDuplicate_Api',
  backend: `Route::post('courses/student/{id}/dismiss-duplicate', 'StudentMergeController@dismissDuplicate');`,
  root: API_ROOT_URL,
  path: '/courses/student/:id/dismiss-duplicate',
  method: 'POST',
}

export const course_mergePreview_Api = {
  name: 'course_mergePreview_Api',
  backend: `Route::get('courses/student/{id}/merge-preview/{target_id}', 'StudentMergeController@mergePreview');`,
  root: API_ROOT_URL,
  path: '/courses/student/:id/merge-preview/:target_id',
  method: 'GET',
}

export const course_executeMerge_Api = {
  name: 'course_executeMerge_Api',
  backend: `Route::post('courses/student/{id}/merge-to/{target_id}', 'StudentMergeController@executeMerge');`,
  root: API_ROOT_URL,
  path: '/courses/student/:id/merge-to/:target_id',
  method: 'POST',
  schema: studentSchema,
  transform: createTransform(studentSchema, 'data'),
}

// =====================================  Student — Identity Verification =====================================

export const course_submitIdentityDocuments_Api = {
  name: 'course_submitIdentityDocuments_Api',
  backend: `Route::post('courses/student/{id}/identity/submit-documents', 'StudentIdentityController@submitDocuments');`,
  root: API_ROOT_URL,
  path: '/courses/student/:id/identity/submit-documents',
  method: 'POST',
  schema: studentSchema,
  transform: createTransform(studentSchema, 'data'),
}

export const course_verifyIdentity_Api = {
  name: 'course_verifyIdentity_Api',
  backend: `Route::post('courses/student/{id}/identity/verify', 'StudentIdentityController@verify');`,
  root: API_ROOT_URL,
  path: '/courses/student/:id/identity/verify',
  method: 'POST',
  schema: studentSchema,
  transform: createTransform(studentSchema, 'data'),
}

export const course_rejectIdentity_Api = {
  name: 'course_rejectIdentity_Api',
  backend: `Route::post('courses/student/{id}/identity/reject', 'StudentIdentityController@reject');`,
  root: API_ROOT_URL,
  path: '/courses/student/:id/identity/reject',
  method: 'POST',
  schema: studentSchema,
  transform: createTransform(studentSchema, 'data'),
}

// ===================================== Subject =====================================
export const subjectSchema = new schema.Entity(
    'subjects',
    {},
    {
        idAttribute: 'id',
    }
)

export const course_getSubjects_Api = {
    name: 'course_getSubjects_Api',
    backend: `Route::get('courses/subject/{type}/{id}/gets', 'SubjectController@getSubjects');`,
    root: API_ROOT_URL,
    path: '/courses/subject/:type/:id/gets',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: subjectSchema,
    transform: createListTransform(subjectSchema),
}

export const course_createSubject_Api = {
    name: 'course_createSubject_Api',
    backend: `Route::post('courses/{type}/{id}/subject/create', 'SubjectController@createSubject');`,
    root: API_ROOT_URL,
    path: '/courses/:type/:id/subject/create',
    method: 'POST',
    schema: subjectSchema,
    transform: createTransform(subjectSchema, 'data'),
}

export const course_deleteSubject_Api = {
    name: 'course_deleteSubject_Api',
    backend: `Route::post('courses/subject/{id}/delete', 'SubjectController@deleteSubject');`,
    root: API_ROOT_URL,
    path: '/courses/subject/:id/delete',
    method: 'POST',
    schema: subjectSchema,
    transform: createTransform(subjectSchema, 'data'),
}

export const course_editSubject_Api = {
    name: 'course_editSubject_Api',
    backend: `Route::post('courses/subject/{id}/edit', 'SubjectController@editSubject');`,
    root: API_ROOT_URL,
    path: '/courses/subject/:id/edit',
    method: 'POST',
    schema: subjectSchema,
    transform: createTransform(subjectSchema, 'data'),
}

export const course_getSubjectById_Api = {
    name: 'course_getSubjectById_Api',
    backend: `Route::get('courses/subject/{id}/get', 'SubjectController@getById');`,
    root: API_ROOT_URL,
    path: '/courses/subject/:id/get',
    method: 'GET',
    schema: subjectSchema,
    transform: createTransform(subjectSchema, 'data'),
}

// ===================================== Classes =====================================
export const courseClassSchema = new schema.Entity(
    'course_class',
    {},
    {
        idAttribute: 'id',
    }
)

export const course_getCourseClassesByOwner_Api = {
    name: 'course_getCourseClassesByOwner_Api',
    backend: `Route::get('courses/course-class/{type}/{id}/gets', 'CourseClassController@getCourseClassesByOwner');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:type/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status', 'course_id'],
    schema: courseClassSchema,
    transform: createListTransform(courseClassSchema),
}

export const course_getCourseClasses_Api = {
    name: 'course_getCourseClasses_Api',
    backend: `Route::get('courses/course/{id}/course-class/gets', 'CourseClassController@getCourseClasses');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/course-class/gets',
    method: 'GET',
    paramsFields: ['keyword', 'admin_only'],
    schema: courseClassSchema,
    transform: createListTransform(courseClassSchema),
}

export const course_createCourseClass_Api = {
    name: 'course_createCourseClass_Api',
    backend: `Route::post('courses/course/{id}/course-class/create', 'CourseClassController@createCourseClass');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/course-class/create',
    method: 'POST',
    schema: courseClassSchema,
    transform: createTransform(courseClassSchema, 'data'),
}

export const course_deleteCourseClass_Api = {
    name: 'course_deleteCourseClass_Api',
    backend: `Route::post('courses/course-class/{id}/delete', 'CourseClassController@deleteCourseClass');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/delete',
    method: 'POST',
    schema: courseClassSchema,
    transform: createTransform(courseClassSchema, 'data'),
}

export const course_editCourseClass_Api = {
    name: 'course_editCourseClass_Api',
    backend: `Route::post('courses/course-class/{id}/edit', 'CourseClassController@editCourseClass');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/edit',
    method: 'POST',
    schema: courseClassSchema,
    transform: createTransform(courseClassSchema, 'data'),
}

export const course_getCourseClassById_Api = {
    name: 'course_getCourseClassById_Api',
    backend: `Route::get('courses/course-class/{id}/get', 'CourseClassController@getById');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/get',
    method: 'GET',
    schema: courseClassSchema,
    transform: createTransform(courseClassSchema, 'data'),
}

export const course_getAttendanceReport_Api = {
    name: 'course_getAttendanceReport_Api',
    backend: `Route::get('courses/course-class/{id}/attendance-report', 'AttendanceController@getAttendanceReport');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/attendance-report',
    method: 'GET',
    paramsFields: ['subject_id'],
}

export const course_class_getSummaryReport_Api = {
    name: 'course_class_getSummaryReport_Api',
    backend: `Route::get('courses/course-class/{id}/summary-report', 'GradeController@getCourseClassSummaryReport');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/summary-report',
    method: 'GET',
    paramsFields: ['subject_id', 'keyword', 'page', 'per_page'],
}

export const course_getAttendanceStatsReport_Api = {
    name: 'course_getAttendanceStatsReport_Api',
    backend: `Route::get('courses/course-class/{id}/subject/{subject_id}/attendance-stats-report', 'AttendanceController@getAttendanceStatsReport');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/subject/:subject_id/attendance-stats-report',
    method: 'GET',
    paramsFields: [],
}

export const course_getAttendanceTrackingSheetReport_Api = {
    name: 'course_getAttendanceTrackingSheetReport_Api',
    backend: `Route::get('courses/course-class/{id}/student/{student_id}/subject/{subject_id}/attendance-tracking-sheet-report', 'AttendanceController@getAttendanceTrackingSheetReport');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/student/:student_id/subject/:subject_id/attendance-tracking-sheet-report',
    method: 'GET',
}

export const course_getGradeReport_Api = {
    name: 'course_getGradeReport_Api',
    backend: `Route::get('courses/course-class/{id}/subject/{subject_id}/grade-report', 'GradeController@getGradeReport');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/subject/:subject_id/grade-report',
    method: 'GET',
}

export const course_getStudentResultReport_Api = {
    name: 'course_getStudentResultReport_Api',
    backend: `Route::get('courses/{type}/{id}/student/{student_id}/get-result-report', 'StudentController@getStudentResultReport');`,
    root: API_ROOT_URL,
    path: '/courses/:type/:id/student/:student_id/get-result-report',
    method: 'GET',
}

export const course_getCourseStudentResultsReport_Api = {
    name: 'course_getStudentResultsByClassReport_Api',
    backend: `Route::get('courses/{id}/get-student-results-report', 'StudentController@getStudentResultsByClassReport');`,
    root: API_ROOT_URL,
    path: '/courses/:id/get-student-results-report',
    method: 'GET',
    paramsFields: ['course_class_id'],
}

export const course_getGradeTrackingSheetReport_Api = {
    name: 'course_getGradeReport_Api',
    backend: `Route::get('courses/course-class/{id}/student/{student_id}/subject/{subject_id}/grade-tracking-sheet-report', 'GradeController@getGradeTrackingSheetReport');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/student/:student_id/subject/:subject_id/grade-tracking-sheet-report',
    method: 'GET',
}

export const course_getCourseClassTransferHistory_Api = {
    name: 'course_getCourseClassTransferHistory_Api',
    backend: `Route::get('courses/course/{id}/transfer/report', 'CourseClassController@getCourseClassTransferHistory');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/transfer/report',
    method: 'GET',
    paramsFields: ['course_class_id'],
}

export const course_getCourseClassesAvailForStudent_Api = {
    name: 'course_getCourseClassesAvailForStudent_Api',
    backend: `Route::get('courses/course/{id}/student/{student_id}/get-avail-course-classes', 'CourseClassController@getCourseClassesAvailForStudent');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/student/:student_id/get-avail-course-classes',
    method: 'GET',
    paramsFields: ['keyword'],
}

// ===================================== courseSubjectSchema =====================================
export const courseSubjectSchema = new schema.Entity(
    'course_subjects',
    {},
    {
        idAttribute: 'id',
    }
)
export const courseClassSubjectSchema = new schema.Entity(
    'course_class_subjects',
    {},
    {
        idAttribute: 'id',
    }
)
export const course_linkSubjectToCourse_Api = {
    name: 'course_linkSubjectToCourse_Api',
    backend: `Route::post('courses/course/{course_id}/subject/{subject_id}/link', 'CourseController@linkSubjectToCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course/:course_id/subject/:subject_id/link',
    method: 'POST',
    schema: courseSubjectSchema,
    transform: createTransform(courseSubjectSchema, 'data'),
}
export const course_unlinkSubjectToCourse_Api = {
    name: 'course_unlinkSubjectToCourse_Api',
    backend: `Route::post('courses/course-subject/{id}/un-link', 'CourseController@unlinkSubjectToCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course-subject/:id/un-link',
    method: 'POST',
    schema: courseSubjectSchema,
    transform: createTransform(courseSubjectSchema, 'data'),
}
export const course_editSubjectParamInCourse_Api = {
    name: 'course_editSubjectParamInCourse_Api',
    backend: `Route::post('courses/course-subject/{id}/edit', 'CourseController@editSubjectParamInCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course-subject/:id/edit',
    method: 'POST',
    schema: courseSubjectSchema,
    transform: createTransform(courseSubjectSchema, 'data'),
}

export const course_getAvailSubjectsForCourse_Api = {
    name: 'course_getAvailSubjectsForCourse_Api',
    backend: `Route::get('courses/course/{id}/course-subject/get-available-for-course', 'SubjectController@getAvailSubjectsForCourse'); `,
    root: API_ROOT_URL,
    path: '/courses/course/:id/course-subject/get-available-for-course',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: courseSubjectSchema,
    transform: createListTransform(courseSubjectSchema),
}


export const course_linkSubjectToCourseClass_Api = {
    name: 'course_linkSubjectToCourseClass_Api',
    backend: `Route::post('courses/course-class/{course_class_id}/subject/{subject_id}/link', 'CourseController@linkSubjectToCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:course_class_id/subject/:subject_id/link',
    method: 'POST',
    schema: courseClassSubjectSchema,
    transform: createTransform(courseClassSubjectSchema, 'data'),
}
export const course_unlinkSubjectToCourseClass_Api = {
    name: 'course_unlinkSubjectToCourseClass_Api',
    backend: `Route::post('courses/course-class-subject/{id}/un-link', 'CourseController@unlinkSubjectToCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-subject/:id/un-link',
    method: 'POST',
    schema: courseClassSubjectSchema,
    transform: createTransform(courseClassSubjectSchema, 'data'),
}
export const course_getAvailSubjectsForCourseClass_Api = {
    name: 'course_getAvailSubjectsForCourseClass_Api',
    backend: `Route::get('courses/course-class/{id}/course-class-subject/get-available-for-course-class', 'SubjectController@getAvailSubjectsForCourseClass'); `,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/course-class-subject/get-available-for-course-class',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: courseClassSubjectSchema,
    transform: createListTransform(courseClassSubjectSchema),
}

export const course_getCourseSubjects_Api = {
    name: 'course_getCourseSubjects_Api',
    backend: `Route::get('courses/course/{id}/course-subject/gets', 'CourseController@getCourseSubjects');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/course-subject/gets',
    method: 'GET',
    paramsFields: ['keyword', 'includes', 'course_class_id'],
    schema: courseSubjectSchema,
    transform: createListTransform(courseSubjectSchema),
}


export const course_getCourseClassSubjects_Api = {
    name: 'course_getCourseClassSubjects_Api',
    backend: `Route::get('courses/course-class/{id}/course-class-subject/gets', 'CourseClassController@getCourseClassSubjects');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/course-class-subject/gets',
    method: 'GET',
    paramsFields: ['keyword', 'includes', 'course_class_id'],
    schema: courseSubjectSchema,
    transform: createListTransform(courseSubjectSchema),
}

// Discovery
export const course_getOpeningCourses_Api = {
    name: 'course_getOpeningCourses_Api',
    backend: `Route::get('courses/course/get-opening-courses', 'CourseController@getOpeningCourses'); `,
    root: API_ROOT_URL,
    path: '/courses/course/get-opening-courses',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: courseSchema,
    transform: createListTransform(courseSchema),
}


export const course_fetchItems_Api = {
    name: 'course_getOpeningCourses_Api',
    backend: `Route::get('courses/fetch-items', 'CourseController@fetchItems');`,
    root: API_ROOT_URL,
    path: '/courses/fetch-items',
    method: 'GET',
    paramsFields: ['keyword', 'time_open_from', 'time_open_to', 'academic_year'],
    schema: courseSchema,
    transform: createListTransform(courseSchema),
}

export const course_getCourseEnrollmentsByAuth_Api = {
    name: 'course_getCourseEnrollmentsByAuth_Api',
    backend: `Route::get('courses/course-enrollment/get-my-enrollments', 'CourseEnrollmentController@getCourseEnrollmentsByAuth');`,
    root: API_ROOT_URL,
    path: '/courses/course-enrollment/get-my-enrollments',
    method: 'GET',
    paramsFields: ['keyword', 'is_self_reg'],
    schema: courseEnrollmentSchema,
    transform: createListTransform(courseEnrollmentSchema),
}

export const course_getCourseClassByAuth_Api = {
    name: 'course_getCourseClassByAuth_Api',
    backend: `Route::get('courses/course-class/get-my-class', 'CourseClassController@getCourseClassByAuth');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/get-my-class',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: courseClassSchema,
    transform: createListTransform(courseClassSchema),
}


// ===================================== courseClassStudentSchema =====================================
export const courseStudentSchema = new schema.Entity(
    'course_students',
    {},
    {
        idAttribute: 'id',
    }
)

export const course_getCourseStudents_Api = {
    name: 'course_getCourseStudents_Api',
    backend: `Route::get('courses/course/{id}/course-student/gets', 'CourseStudentController@getCourseStudents');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/course-student/gets',
    method: 'GET',
    paramsFields: ['keyword', 'course_class_id', 'subject_id'],
    schema: courseStudentSchema,
    transform: createListTransform(courseStudentSchema),
}

export const course_getCourseStudentsByAuth_Api = {
    name: 'course_getCourseStudentsByAuth_Api',
    backend: `Route::get('courses/course/get-my-courses', 'CourseController@getCourseStudentsByAuth');`,
    root: API_ROOT_URL,
    path: '/courses/course/get-my-courses',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: courseStudentSchema,
    transform: createListTransform(courseStudentSchema),
}

export const course_assignStudentToCourse_Api = {
    name: 'course_assignStudentToCourse_Api',
    backend: `Route::post('courses/course/{course_id}/student/{student_id}/link', 'CourseStudentController@assignStudentToCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course/:course_id/student/:student_id/link',
    method: 'POST',
    schema: courseStudentSchema,
    transform: createTransform(courseStudentSchema, 'data'),
}

export const course_assignMultiStudentToCourse_Api = {
    name: 'course_assignMultiStudentToCourse_Api',
    backend: `Route::post('courses/course/{course_id}/student/add-multi', 'CourseStudentController@assignMultiStudentToCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course/:course_id/student/add-multi',
    method: 'POST',
    schema: courseSchema,
    transform: createTransform(courseSchema, 'data'),
}

export const course_editStudentFromCourse_Api = {
    name: 'course_editStudentFromCourse_Api',
    backend: `Route::post('courses/course-student/{id}/edit', 'CourseStudentController@editStudentFromCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course-student/:id/edit',
    method: 'POST',
    schema: courseStudentSchema,
    transform: createTransform(courseStudentSchema, 'data'),
}
export const course_updateResultStatus_Api = {
    name: 'course_updateResultStatus_Api',
    backend: `Route::post('courses/course-student/{id}/update-result-status', 'CourseStudentController@updateResultStatus');`,
    root: API_ROOT_URL,
    path: '/courses/course-student/:id/update-result-status',
    method: 'POST',
    schema: courseStudentSchema,
    transform: createTransform(courseStudentSchema, 'data'),
}
export const course_revokeStudentFromCourse_Api = {
    name: 'course_revokeStudentFromCourse_Api',
    backend: `Route::post('courses/course-student/{id}/un-link', 'CourseStudentController@revokeStudentFromCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course-student/:id/un-link',
    method: 'POST',
    schema: courseStudentSchema,
    transform: createTransform(courseStudentSchema, 'data'),
}


// ===================================== courseClassStudentSchema =====================================
export const courseClassStudentSchema = new schema.Entity(
    'course_class_students',
    {},
    {
        idAttribute: 'id',
    }
)

export const course_getCourseClassStudents_Api = {
    name: 'course_getCourseClassStudents_Api',
    backend: `Route::get('courses/course-class/{id}/course-class-student/gets', 'CourseClassStudentController@getCourseClassStudents');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/course-class-student/gets',
    method: 'GET',
    paramsFields: ['keyword', 'sub_class_name', 'subject_id'],
    schema: courseClassStudentSchema,
    transform: createListTransform(courseClassStudentSchema),
}

export const course_assignStudentToCourseClass_Api = {
    name: 'course_assignStudentToCourseClass_Api',
    backend: `Route::post('courses/course-class/{course_class_id}/student/{student_id}/link', 'CourseClassStudentController@assignStudentToCourseClass');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:course_class_id/student/:student_id/link',
    method: 'POST',
    schema: courseClassStudentSchema,
    transform: createTransform(courseClassStudentSchema, 'data'),
}
export const course_assignMultiStudentToCourseClass_Api = {
    name: 'course_assignMultiStudentToCourseClass_Api',
    backend: `Route::post('courses/course-class/{course_class_id}/student/add-multi', 'CourseClassStudentController@assignMultiStudentToCourseClass');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:course_class_id/student/add-multi',
    method: 'POST',
    schema: courseClassSchema,
    transform: createTransform(courseClassSchema, 'data'),
}
export const course_editStudentFromCourseClass_Api = {
    name: 'course_editStudentFromCourseClass_Api',
    backend: `Route::post('courses/course-class-student/{id}/edit', 'CourseClassStudentController@editStudentFromCourseClass');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-student/:id/edit',
    method: 'POST',
    schema: courseClassStudentSchema,
    transform: createTransform(courseClassStudentSchema, 'data'),
}
export const course_revokeStudentFromCourseClass_Api = {
    name: 'course_revokeStudentFromCourseClass_Api',
    backend: `Route::post('courses/course-class-student/{id}/un-link', 'CourseClassStudentController@revokeStudentFromCourseClass');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-student/:id/un-link',
    method: 'POST',
    schema: courseClassStudentSchema,
    transform: createTransform(courseClassStudentSchema, 'data'),
}
export const course_transferStudentFromCourseClassTo_Api = {
    name: 'course_transferStudentFromCourseClassTo_Api',
    backend: `Route::post('courses/course-class-student/{id}/transfer-to/{course_class_id}/set', 'CourseClassStudentController@transferStudentFromCourseClassTo');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-student/:course_class_student_id/transfer-to/:course_class_id/set',
    method: 'POST',
    schema: courseClassStudentSchema,
    transform: createTransform(courseClassStudentSchema, 'data'),
}

// ===================================== Subject =====================================
export const courseClassAttendanceSchema = new schema.Entity(
    'attendance',
    {},
    {
        idAttribute: 'id',
    }
)
export const courseClassAttendanceDetailSchema = new schema.Entity(
    'attendance_detail',
    {},
    {
        idAttribute: 'id',
    }
)

export const course_class_getAttendances_Api = {
    name: 'course_class_getAttendances_Api',
    backend: `Route::get('courses/course-class/{id}/attendance/gets', 'AttendanceController@getAttendances');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/attendance/gets',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'subject_id'],
    schema: courseClassAttendanceSchema,
    transform: createListTransform(courseClassAttendanceSchema),
}
export const course_class_getAttendanceDetails_Api = {
    name: 'course_class_getAttendanceDetails_Api',
    backend: `Route::get('courses/attendance/{id}/attendance-detail/gets', 'AttendanceController@getAttendanceDetails');`,
    root: API_ROOT_URL,
    path: '/courses/attendance/:id/attendance-detail/gets',
    method: 'GET',
    paramsFields: ['keyword', 'sub_class_name', 'status'],
    schema: courseClassAttendanceDetailSchema,
    transform: createListTransform(courseClassAttendanceDetailSchema),
}
export const course_class_getAttendanceDetailsByStudent_Api = {
    name: 'course_class_getAttendanceDetailsByStudent_Api',
    backend: `Route::get('courses/course-class/{id}/student/{student_id}/attendance-detail/gets', 'AttendanceController@getAttendanceDetailsByStudent');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/student/:student_id/attendance-detail/gets',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: courseClassAttendanceDetailSchema,
    transform: createListTransform(courseClassAttendanceDetailSchema),
}

export const course_class_createAttendance_Api = {
    name: 'course_class_createAttendance_Api',
    backend: `Route::post('courses/course-class/{id}/attendance/create', 'AttendanceController@createAttendance');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/attendance/create',
    method: 'POST',
    schema: courseClassAttendanceSchema,
    transform: createTransform(courseClassAttendanceSchema, 'data'),
}

export const course_class_deleteAttendance_Api = {
    name: 'course_class_deleteAttendance_Api',
    backend: `Route::post('courses/attendance/{id}/delete', 'AttendanceController@deleteAttendance');`,
    root: API_ROOT_URL,
    path: '/courses/attendance/:id/delete',
    method: 'POST',
    schema: courseClassAttendanceSchema,
    transform: createTransform(courseClassAttendanceSchema, 'data'),
}

export const course_class_editAttendance_Api = {
    name: 'course_class_editAttendance_Api',
    backend: `Route::post('courses/attendance/{id}/edit', 'AttendanceController@editAttendance');`,
    root: API_ROOT_URL,
    path: '/courses/attendance/:id/edit',
    method: 'POST',
    schema: courseClassAttendanceSchema,
    transform: createTransform(courseClassAttendanceSchema, 'data'),
}

export const course_class_getAttendanceById_Api = {
    name: 'course_class_getAttendanceById_Api',
    backend: `Route::get('courses/attendance/{id}/get', 'AttendanceController@getById');`,
    root: API_ROOT_URL,
    path: '/courses/attendance/:id/get',
    method: 'GET',
    schema: courseClassAttendanceSchema,
    transform: createTransform(courseClassAttendanceSchema, 'data'),
}
export const course_class_setAttendanceStatus_Api = {
    name: 'course_class_setAttendanceStatus_Api',
    backend: `Route::post('courses/attendance/{attendance_id}/attendance-detail/{id}/set-status', 'AttendanceController@setAttendanceStatus');`,
    root: API_ROOT_URL,
    path: '/courses/attendance/:attendance_id/attendance-detail/:detail_id/set-status',
    method: 'POST',
    schema: courseClassAttendanceDetailSchema,
    transform: createTransform(courseClassAttendanceDetailSchema, 'data'),
}
// Route::post('courses/attendance/{attendance_id}/set-check-in', 'AttendanceController@attendanceCheckIn');
export const course_class_attendanceCheckIn_Api = {
    name: 'course_class_attendanceCheckIn_Api',
    backend: `Route::post('courses/attendance/{attendance_id}/set-check-in', 'AttendanceController@attendanceCheckIn');`,
    root: API_ROOT_URL,
    path: '/courses/attendance/:attendance_id/set-check-in',
    method: 'POST',
    schema: courseClassAttendanceDetailSchema,
    transform: createTransform(courseClassAttendanceDetailSchema, 'data'),
}


// ===================================== Subject =====================================
export const courseClassGradeSchema = new schema.Entity(
    'grade',
    {},
    {
        idAttribute: 'id',
    }
)
export const courseClassGradeDetailSchema = new schema.Entity(
    'grade_detail',
    {},
    {
        idAttribute: 'id',
    }
)

export const course_class_getGrades_Api = {
    name: 'course_class_getAttendances_Api',
    backend: `Route::get('courses/course-class/{id}/grade/gets', 'GradeController@getGrades');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/grade/gets',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'subject_id'],
    schema: courseClassGradeSchema,
    transform: createListTransform(courseClassGradeSchema),
}

export const course_getGradeByStudentReportByAuth_Api = {
    name: 'course_getGradeByStudentReportByAuth_Api',
    backend: `Route::get('courses/course-class/{id}/grade/report-auth', 'GradeController@getGradeByStudentReportByAuth');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/grade/report-auth',
    method: 'GET',
}

export const course_class_getGradeDetailsByAuth_Api = {
    name: 'course_class_getGradeDetailsByAuth_Api',
    backend: `Route::get('courses/course-class/{id}/grade-detail/gets-auth', 'GradeController@getGradeDetailsByAuth');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/grade-detail/gets-auth',
    method: 'GET',
    schema: courseClassGradeDetailSchema,
    transform: createListTransform(courseClassGradeDetailSchema),
}

export const course_getAttendanceByStudentReportByAuth_Api = {
    name: 'course_getAttendanceByStudentReportByAuth_Api',
    backend: `Route::get('courses/course-class/{id}/attendance/report-auth', 'AttendanceController@getAttendanceByStudentReportByAuth');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/attendance/report-auth',
    method: 'GET',
}

export const course_class_getAttendanceDetailsByAuth_Api = {
    name: 'course_class_getAttendanceDetailsByAuth_Api',
    backend: `Route::get('courses/course-class/{id}/attendance-detail/gets-auth', 'AttendanceController@getAttendanceDetailsByAuth');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/attendance-detail/gets-auth',
    method: 'GET',
    schema: courseClassAttendanceDetailSchema,
    transform: createListTransform(courseClassAttendanceDetailSchema),
}

export const course_class_getGradeDetails_Api = {
    name: 'course_class_getGradeDetails_Api',
    backend: `Route::get('courses/grade/{id}/grade-detail/gets', 'GradeController@getGradeDetails');`,
    root: API_ROOT_URL,
    path: '/courses/grade/:id/grade-detail/gets',
    method: 'GET',
    paramsFields: ['keyword', 'sub_class_name'],
    schema: courseClassGradeDetailSchema,
    transform: createListTransform(courseClassGradeDetailSchema),
}

export const course_class_createGrade_Api = {
    name: 'course_class_createGrade_Api',
    backend: `Route::post('courses/course/{id}/grade/create', 'GradeController@createGrade');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/grade/create',
    method: 'POST',
    schema: courseClassGradeSchema,
    transform: createTransform(courseClassGradeSchema, 'data'),
}

export const course_class_deleteGrade_Api = {
    name: 'course_class_deleteGrade_Api',
    backend: `Route::post('courses/grade/{id}/delete', 'GradeController@deleteGrade');`,
    root: API_ROOT_URL,
    path: '/courses/grade/:id/delete',
    method: 'POST',
    schema: courseClassGradeSchema,
    transform: createTransform(courseClassGradeSchema, 'data'),
}

export const course_class_editGrade_Api = {
    name: 'course_class_editGrade_Api',
    backend: `Route::post('courses/grade/{id}/edit', 'GradeController@editGrade');`,
    root: API_ROOT_URL,
    path: '/courses/grade/:id/edit',
    method: 'POST',
    schema: courseClassGradeSchema,
    transform: createTransform(courseClassGradeSchema, 'data'),
}

export const course_class_getGradeById_Api = {
    name: 'course_class_getGradeById_Api',
    backend: `Route::get('courses/grade/{id}/get', 'GradeController@getById');`,
    root: API_ROOT_URL,
    path: '/courses/grade/:id/get',
    method: 'GET',
    schema: courseClassGradeSchema,
    transform: createTransform(courseClassGradeSchema, 'data'),
}

export const course_class_setGradeScore_Api = {
    name: 'course_class_setGradeScore_Api',
    backend: `Route::post('courses/grade/{grade_id}/grade-detail/{id}/set-status', 'GradeController@setGradeScore');`,
    root: API_ROOT_URL,
    path: '/courses/grade/:grade_id/grade-detail/:detail_id/set-status',
    method: 'POST',
    schema: courseClassGradeDetailSchema,
    transform: createTransform(courseClassGradeDetailSchema, 'data'),
}

// ===================================== Result =====================================
export const studentSubjectResultSchema = new schema.Entity(
    'student_subject_results',
    {},
    {
        idAttribute: 'id',
    }
)
export const courseStudentSubjectResultSchema = new schema.Entity(
    'course_student_subject_results',
    {},
    {
        idAttribute: 'id',
    }
)

export const course_getDetailByCourseStudentSubject_Api = {
    name: 'course_getDetailByCourseStudentSubject_Api',
    backend: `Route::get('courses/course/{course_id}/student/{student_id}/subject/{subject_id}/get-detail', 'StudentSubjectResultController@getDetailByCourseStudentSubject');`,
    root: API_ROOT_URL,
    path: '/courses/course/:course_id/student/:student_id/subject/:subject_id/get-detail',
    method: 'GET',
    schema: courseStudentSubjectResultSchema,
    transform: createTransform(courseStudentSubjectResultSchema, 'data'),
}

export const course_getCourseSubjectsByCourseStudent_Api = {
    name: 'course_getCourseSubjectsByCourseStudent_Api',
    backend: `Route::get('courses/course/{course_id}/student/{student_id}/get-summary-subjects', 'StudentSubjectResultController@getCourseSubjectsByCourseStudent');`,
    root: API_ROOT_URL,
    path: '/courses/course/:course_id/student/:student_id/get-summary-subjects',
    method: 'GET',
    schema: courseStudentSubjectResultSchema,
    transform: createListTransform(courseStudentSubjectResultSchema),
}

export const course_getSubjectResultsByCourseClassStudent_Api = {
    name: 'course_getSubjectResultsByCourseClassStudent_Api',
    backend: `Route::get('courses/student/{student_id}/get-subject-results', 'StudentSubjectResultController@getSubjectResultsByCourseClassStudent');`,
    root: API_ROOT_URL,
    path: '/courses/student/:student_id/get-subject-results',
    method: 'GET',
    paramsFields: ['course_id'],
    schema: studentSubjectResultSchema,
    transform: createListTransform(studentSubjectResultSchema),
}

export const course_class_student_subject_deleteResult_Api = {
    name: 'course_class_student_subject_deleteResult_Api',
    backend: `Route::post('courses/student-subject-result/{id}/delete', 'StudentSubjectResultController@deleteResult');`,
    root: API_ROOT_URL,
    path: '/courses/student-subject-result/:id/delete',
    method: 'POST',
    schema: studentSubjectResultSchema,
    transform: createTransform(studentSubjectResultSchema, 'data'),
}

export const course_class_student_subject_editResult_Api = {
    name: 'course_class_student_subject_editResult_Api',
    backend: `Route::post('courses/student-subject-result/{id}/edit', 'StudentSubjectResultController@editResult');`,
    root: API_ROOT_URL,
    path: '/courses/student-subject-result/:id/edit',
    method: 'POST',
    schema: studentSubjectResultSchema,
    transform: createTransform(studentSubjectResultSchema, 'data'),
}

export const course_student_subject_createResult_Api = {
    name: 'course_class_student_subject_createResult_Api',
    backend: `Route::post('courses/course/{course_id}/student/{student_id}/subject/{subject_id}/create', 'StudentSubjectResultController@createResult');`,
    root: API_ROOT_URL,
    path: '/courses/course/:course_id/student/:student_id/subject/:subject_id/create',
    method: 'POST',
    schema: studentSubjectResultSchema,
    transform: createTransform(studentSubjectResultSchema, 'data'),
}

export const course_createAllResultForCourse_Api = {
    name: 'course_createAllResultForCourse_Api',
    backend: `Route::post('courses/course/{course_id}/student-subject-result/create', 'StudentSubjectResultController@createAllResultForCourse');`,
    root: API_ROOT_URL,
    path: '/courses/course/:course_id/student-subject-result/create',
    method: 'POST',
    schema: courseSchema,
    transform: createTransform(courseSchema, 'data'),
}

export const course_class_student_getAttendanceResult_Api = {
    name: 'course_class_student_getAttendanceResult_Api',
    backend: `Route::get('courses/course-class/{id}/subject/{subject_id}/course-class-student/attendance/gets', 'CourseClassStudentController@getCourseClassStudentWithAttendances');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:course_class_id/subject/:subject_id/course-class-student/attendance/gets',
    method: 'GET',
    paramsFields: ['range', 'keyword'],
    schema: courseClassStudentSchema,
    transform: createListTransform(courseClassStudentSchema),
}

export const course_class_student_getGradeResult_Api = {
    name: 'course_class_student_getGradeResult_Api',
    backend: `Route::get('courses/course-class/{id}/subject/{subject_id}/course-class-student/grade/gets', 'CourseClassStudentController@getCourseClassStudentWithGrades');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:course_class_id/subject/:subject_id/course-class-student/grade/gets',
    method: 'GET',
    schema: courseClassStudentSchema,
    transform: createListTransform(courseClassStudentSchema),
}


export const course_generateExportFile_Api = {
    name: 'course_generateExportFile_Api',
    backend: `Route::post('courses/{id}/students/generate-export-file', 'CourseClassStudentController@generateExportFile');`,
    root: API_ROOT_URL,
    path: '/courses/:id/students/generate-export-file',
    method: 'POST',
}
export const course_generateAttendanceExportFile_Api = {
    name: 'course_generateAttendanceExportFile_Api',
    backend: `Route::post('courses/{id}/attendances/generate-export-file', 'AttendanceController@generateExportFile');`,
    root: API_ROOT_URL,
    path: '/courses/:id/attendances/generate-export-file',
    method: 'POST',
}
export const course_generateGradeExportFile_Api = {
    name: 'course_generateGradeExportFile_Api',
    backend: `Route::post('courses/{id}/grades/generate-export-file', 'GradeController@generateExportFile');`,
    root: API_ROOT_URL,
    path: '/courses/:id/grades/generate-export-file',
    method: 'POST',
}

export const course_doCourseStudentImportFile_Api = {
    name: 'course_doCourseStudentImportFile_Api',
    backend: `Route::post('courses/{id}/students/do-import-file', 'CourseClassStudentController@generateExportFile');`,
    root: API_ROOT_URL,
    path: '/courses/:id/students/do-import-file',
    method: 'POST',
}

export const course_doCourseAttendanceImportFile_Api = {
    name: 'course_doCourseAttendanceImportFile_Api',
    backend: `Route::post('courses/{id}/attendances/do-import-file', 'AttendanceController@generateExportFile');`,
    root: API_ROOT_URL,
    path: '/courses/:id/attendances/do-import-file',
    method: 'POST',
}

export const course_doCourseGradeImportFile_Api = {
    name: 'course_doCourseGradeImportFile_Api',
    backend: `Route::post('courses/{id}/grades/do-import-file', 'GradeController@generateExportFile');`,
    root: API_ROOT_URL,
    path: '/courses/:id/grades/do-import-file',
    method: 'POST',
}


export const course_fetchSuggestionCourseAppChoices_Api = {
    name: 'course_fetchSuggestionCourseAppChoices_Api',
    backend: `Route::get('recommendations/course/suggested-items', 'PromoteController@getCourses');`,
    root: API_ROOT_URL,
    path: '/recommendations/course/suggested-items',
    method: 'GET',
    paramsFields: ['category_id'],
    schema: courseSchema,
    transform: createListTransform(courseSchema),
}


export const medal_assignNewMedalToStudentByMerging_Api = {
    backend: `Route::post('courses/{type}/{id}/student/merge-medal', 'StudentController@assignNewMedalByMerging');`,
    root: API_ROOT_URL,
    path: '/courses/:type/:id/student/merge-medal',
    method: 'POST',
    schema: organizationSchema,
    transform: createTransform(organizationSchema, 'data'),
}


export const course_getStudentsByAuth_Api = {
    name: 'course_getStudentsByAuth_Api',
    backend: `Route::get('courses/student/get-my-students', 'CourseController@getStudentsByAuth');`,
    root: API_ROOT_URL,
    path: '/courses/student/get-my-students',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: studentSchema,
    transform: createListTransform(studentSchema),
}


export const course_grantCertificateToStudentInCourse_Api = {
    name: 'course_grantCertificateToStudentInCourse_Api',
    backend: `Route::post('courses/{id}/medal/grant-to-all-students', 'CourseController@grantCertificateToStudentInCourse');`,
    root: API_ROOT_URL,
    path: '/courses/:id/medal/grant-to-all-students',
    method: 'POST',
    schema: courseSchema,
    transform: createTransform(courseSchema, 'data'),
}

export const course_revokeCertificateFromStudentInCourse_Api = {
    name: 'course_revokeCertificateFromStudentInCourse_Api',
    backend: `Route::post('courses/{id}/medal/revoke-from-all-students', 'CourseController@revokeCertificateFromStudentInCourse');`,
    root: API_ROOT_URL,
    path: '/courses/:id/medal/revoke-from-all-students',
    method: 'POST',
    schema: courseSchema,
    transform: createTransform(courseSchema, 'data'),
}

export const course_revokeCertificateFromStudent_Api = {
    name: 'course_revokeCertificateFromStudent_Api',
    backend: `Route::post('courses/{id}/student/{student_id}/medal/revoke-medal', 'CourseController@revokeCertificateFromStudent');`,
    root: API_ROOT_URL,
    path: '/courses/:id/student/:student_id/medal/revoke-medal',
    method: 'POST',
    schema: courseSchema,
    transform: createTransform(courseSchema, 'data'),
}
export const course_assignNewMedalByMerging_Api = {
    name: 'course_assignNewMedalByMerging_Api',
    backend: `Route::post('courses/{id}/medal/merge-medal', 'CourseController@assignNewMedalByMerging');`,
    root: API_ROOT_URL,
    path: '/courses/:id/medal/merge-medal',
    method: 'POST',
    schema: courseSchema,
    transform: createTransform(courseSchema, 'data'),
}

// ===================================== Enrollment Pipeline =====================================
export const course_enrollment_searchCandidates_Api = {
    name: 'course_enrollment_searchCandidates_Api',
    backend: `Route::post('courses/course-enrollment/{id}/search-candidates', 'CourseEnrollmentController@searchCandidates');`,
    root: API_ROOT_URL,
    path: '/courses/course-enrollment/:id/search-candidates',
    method: 'POST',
}

export const course_enrollment_resetToPending_Api = {
    name: 'course_enrollment_resetToPending_Api',
    backend: `Route::post('courses/course-enrollment/{id}/reset-to-pending', 'CourseEnrollmentController@resetToPending');`,
    root: API_ROOT_URL,
    path: '/courses/course-enrollment/:id/reset-to-pending',
    method: 'POST',
    schema: courseEnrollmentSchema,
    transform: createTransform(courseEnrollmentSchema, 'data'),
}

export const course_enrollment_startReview_Api = {
    name: 'course_enrollment_startReview_Api',
    backend: `Route::patch('courses/course-enrollment/{id}/start-review', 'CourseEnrollmentController@startReview');`,
    root: API_ROOT_URL,
    path: '/courses/course-enrollment/:id/start-review',
    method: 'POST',
    schema: courseEnrollmentSchema,
    transform: createTransform(courseEnrollmentSchema, 'data'),
}

export const course_enrollment_resolveIdentity_Api = {
    name: 'course_enrollment_resolveIdentity_Api',
    backend: `Route::patch('courses/course-enrollment/{id}/resolve-identity', 'CourseEnrollmentController@resolveIdentity');`,
    root: API_ROOT_URL,
    path: '/courses/course-enrollment/:id/resolve-identity',
    method: 'POST',
    schema: courseEnrollmentSchema,
    transform: createTransform(courseEnrollmentSchema, 'data'),
}

export const course_enrollment_assignClass_Api = {
    name: 'course_enrollment_assignClass_Api',
    backend: `Route::patch('courses/course-enrollment/{id}/assign-class', 'CourseEnrollmentController@assignClass');`,
    root: API_ROOT_URL,
    path: '/courses/course-enrollment/:id/assign-class',
    method: 'POST',
    schema: courseEnrollmentSchema,
    transform: createTransform(courseEnrollmentSchema, 'data'),
}

export const course_getGraduationReview_Api = {
    name: 'course_getGraduationReview_Api',
    backend: `Route::get('courses/course/{id}/graduation-review', 'GraduationReviewController@getGraduationReview');`,
    root: API_ROOT_URL,
    path: '/courses/course/:id/graduation-review',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: courseStudentSchema,
    transform: createListTransform(courseStudentSchema),
}

export const course_getStudentSubjectHistory_Api = {
    name: 'course_getStudentSubjectHistory_Api',
    backend: `Route::get('courses/course/{course_id}/student/{student_id}/subject/{subject_id}/history', 'GraduationReviewController@getStudentSubjectHistory');`,
    root: API_ROOT_URL,
    path: '/courses/course/:course_id/student/:student_id/subject/:subject_id/history',
    method: 'GET',
    schema: studentSubjectResultSchema,
    transform: createListTransform(studentSubjectResultSchema),
}


export const student_getAttendanceSheetByStudent_Api = {
    name: 'student_getAttendanceHistoryByStudent_Api',
    backend: `Route::get('courses/student/{student_id}/attendance/gets', 'AttendanceController@getAttendanceSheetByStudent');`,
    root: API_ROOT_URL,
    path: '/courses/student/:id/attendance/gets',
    method: 'GET',
    paramsFields: ['keyword', 'course_class_id', 'subject_id', 'month_number', 'year_number'],
    schema: courseClassAttendanceDetailSchema,
    transform: createListTransform(courseClassAttendanceDetailSchema),
}

export const student_getGradeSheetByStudent_Api = {
    name: 'student_getGradeSheetByStudent_Api',
    backend: `Route::get('courses/student/{student_id}/grade/gets', 'GradeController@getGradeSheetByStudent');`,
    root: API_ROOT_URL,
    path: '/courses/student/:id/grade/gets',
    method: 'GET',
    paramsFields: ['keyword', 'course_class_id', 'subject_id'],
    schema: courseClassGradeDetailSchema,
    transform: createListTransform(courseClassGradeDetailSchema),
}

export const teacher_getAttendanceSheetByTeacher_Api = {
    name: 'teacher_getAttendanceSheetByTeacher_Api',
    backend: `Route::get('courses/teacher/{teacher_id}/attendance/gets', 'AttendanceController@getAttendanceSheetByTeacher');`,
    root: API_ROOT_URL,
    path: '/courses/teacher/:id/attendance/gets',
    method: 'GET',
    paramsFields: ['keyword', 'course_class_id', 'subject_id', 'month_number', 'year_number'],
    schema: courseClassAttendanceDetailSchema,
    transform: createListTransform(courseClassAttendanceDetailSchema),
}

export const teacher_getGradeSheetByTeacher_Api = {
    name: 'teacher_getGradeSheetByTeacher_Api',
    backend: `Route::get('courses/teacher/{teacher_id}/grade/gets', 'GradeController@getGradeSheetByTeacher');`,
    root: API_ROOT_URL,
    path: '/courses/teacher/:id/grade/gets',
    method: 'GET',
    paramsFields: ['keyword', 'course_class_id', 'subject_id'],
    schema: courseClassGradeDetailSchema,
    transform: createListTransform(courseClassGradeDetailSchema),
}

/// =================================================

export const courseClassExamSchema = new schema.Entity(
    'course_class_exam',
    {},
    {
        idAttribute: 'id',
    }
)
export const courseClassExamAttemptSchema = new schema.Entity(
    'course_class_exam_attempts',
    {},
    {
        idAttribute: 'id',
    }
)


export const course_class_exam_update_Api = {
    name: 'course_class_exam_update_Api',
    backend: `// Route::post('courses/course-class-exam/{id}/update', 'CourseClassExamController@update');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-exam/:id/update',
    method: 'POST',
    schema: courseClassExamSchema,
    transform: createTransform(courseClassExamSchema, 'data'),
}

export const course_class_exam_getById_Api = {
    name: 'course_class_exam_getById_Api',
    backend: `// Route::get('courses/course-class-exam/{id}/get', 'CourseClassExamController@getById');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-exam/:id/get',
    method: 'GET',
    paramsFields: ['keyword', 'course_class_id', 'subject_id', 'month_number', 'year_number'],
    schema: courseClassExamSchema,
    transform: createTransform(courseClassExamSchema),
}


export const course_class_exam_initExamAttempt_Api = {
    name: 'course_class_exam_initExamAttempt_Api',
    backend: `Route::post('courses/course-class-exam/{id}/init-exam-attempt', 'CourseClassExamAttemptController@initExamAttempt');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-exam/:id/init-exam-attempt',
    method: 'POST',
    schema: courseClassExamAttemptSchema,
    transform: createTransform(courseClassExamAttemptSchema, 'data'),
}

export const course_class_exam_fetchAttempts_Api = {
    name: 'course_class_exam_fetchAttempts_Api',
    backend: `Route::get('courses/course-class-exam/{id}/get-attempts', 'CourseClassExamAttemptController@fetchItems');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-exam/:id/get-attempts',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: courseClassExamAttemptSchema,
    transform: createListTransform(courseClassExamAttemptSchema),
}

export const course_class_exam_updateExamAttemptAnswer_Api = {
    name: 'course_class_exam_updateExamAttemptAnswer_Api',
    backend: `Route::post('courses/course-class-exam-attempt/{id}/update-answer', 'CourseClassExamAttemptController@updateExamAttemptAnswer');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-exam-attempt/:id/update-answer',
    method: 'POST',
    schema: courseClassExamAttemptSchema,
    transform: createTransform(courseClassExamAttemptSchema, 'data'),
}

export const course_class_exam_submitExamAttempt_Api = {
    name: 'course_class_exam_submitExamAttempt_Api',
    backend: `// Route::post('courses/course-class-exam-attempt/{id}/submit', 'CourseClassExamAttemptController@submitExamAttempt');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-exam-attempt/:id/submit',
    method: 'POST',
    schema: courseClassExamAttemptSchema,
    transform: createTransform(courseClassExamAttemptSchema, 'data'),
}


export const course_class_exam_evaluateExamAttempt_Api = {
    name: 'course_class_exam_evaluateExamAttempt_Api',
    backend: `// Route::post('courses/course-class-exam-attempt/{id}/evaluate', 'CourseClassExamAttemptController@course_class_exam_evaluateExamAttempt_Api');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-exam-attempt/:id/evaluate',
    method: 'POST',
    schema: courseClassExamAttemptSchema,
    transform: createTransform(courseClassExamAttemptSchema, 'data'),
}

export const course_class_exam_removeExamAttempt_Api = {
    name: 'course_class_exam_removeExamAttempt_Api',
    backend: `// Route::post('courses/course-class-exam-attempt/{id}/remove', 'CourseClassExamAttemptController@removeExamAttempt');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-exam-attempt/:id/remove',
    method: 'POST',
    schema: courseClassExamAttemptSchema,
    transform: createTransform(courseClassExamAttemptSchema, 'data'),
}

export const course_class_exam_attempt_getById_Api = {
    name: 'course_class_exam_attempt_getById_Api',
    backend: `// Route::get('courses/course-class-exam-attempt/{id}/get', 'CourseClassExamAttemptController@getById');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-exam-attempt/:id/get',
    method: 'GET',
    schema: courseClassExamAttemptSchema,
    transform: createTransform(courseClassExamAttemptSchema),
}

export const course_class_exam_getExamsByOrganization_Api = {
    name: 'course_class_exam_getExamsByOrganization_Api',
    backend: `// Route::get('courses/organization/{id}/fetch-exams', 'CourseClassExamController@getExamsByOrganization');`,
    root: API_ROOT_URL,
    path: '/courses/organization/:id/fetch-exams',
    method: 'GET',
    schema: courseClassExamSchema,
    transform: createListTransform(courseClassExamSchema),
}

// Search câu hỏi từ quiz_questions (cross-all, không filter owner)
export const course_quiz_questions_search_Api = {
    name: 'course_quiz_questions_search_Api',
    backend: `// Route::get('courses/quiz-questions/search', 'CourseClassExamController@searchQuizQuestions');`,
    root: API_ROOT_URL,
    path: '/courses/quiz-questions/search',
    method: 'GET',
    paramsFields: ['q', 'limit'],
}

// fetchAttempts với filter status
export const course_class_exam_fetchAttemptsFiltered_Api = {
    name: 'course_class_exam_fetchAttemptsFiltered_Api',
    backend: `// Route::get('courses/course-class-exam/{id}/get-attempts', 'CourseClassExamAttemptController@fetchItems');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-exam/:id/get-attempts',
    method: 'GET',
    paramsFields: ['status', 'keyword'],
    schema: courseClassExamAttemptSchema,
    transform: createListTransform(courseClassExamAttemptSchema),
}


export const courseClassAbsenceRequestSchema = new schema.Entity(
    'course_class_absence_requests',
    {},
    {
        idAttribute: 'id',
    }
)

export const course_class_getAbsenceRequestsByStudent_Api = {
    name: 'course_class_getAbsenceRequestsByStudent_Api',
    backend: `Route::get('courses/student/{id}/course-class-absence-request/gets', 'CourseClassAbsenceRequestController@getAbsenceRequestsByStudent');`,
    root: API_ROOT_URL,
    path: '/courses/student/:id/course-class-absence-request/gets',
    method: 'GET',
    paramsFields: ['keyword', 'course_class_id', 'subject_id'],
    schema: courseClassAbsenceRequestSchema,
    transform: createListTransform(courseClassAbsenceRequestSchema),
}

export const course_class_getAbsenceRequestsByTeacher_Api = {
    name: 'course_class_getAbsenceRequestsByTeacher_Api',
    backend: `Route::get('courses/teacher/{id}/course-class-absence-request/gets', 'CourseClassAbsenceRequestController@getAbsenceRequestsByTeacher');`,
    root: API_ROOT_URL,
    path: '/courses/teacher/:id/course-class-absence-request/gets',
    method: 'GET',
    paramsFields: ['keyword', 'course_class_id', 'subject_id'],
    schema: courseClassAbsenceRequestSchema,
    transform: createListTransform(courseClassAbsenceRequestSchema),
}
export const course_class_createAbsenceRequest_Api = {
    name: 'course_class_createAbsenceRequest_Api',
    backend: `Route::post('courses/course-class/{id}/create-absence-request', 'CourseClassAbsenceRequestController@createAbsenceRequest');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/create-absence-request',
    method: 'POST',
    schema: courseClassAbsenceRequestSchema,
    transform: createTransform(courseClassAbsenceRequestSchema, 'data'),
}
export const course_class_cancelAbsenceRequest_Api = {
    name: 'course_class_cancelAbsenceRequest_Api',
    backend: `Route::post('courses/course-class-absence-request/{id}/cancel-absence-request', 'CourseClassAbsenceRequestController@cancelAbsenceRequest');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-absence-request/:id/cancel-absence-request',
    method: 'POST',
    schema: courseClassAbsenceRequestSchema,
    transform: createTransform(courseClassAbsenceRequestSchema, 'data'),
}
export const course_class_acceptAbsenceRequest_Api = {
    name: 'course_class_acceptAbsenceRequest_Api',
    backend: `Route::post('courses/course-class-absence-request/{id}/accept-absence-request', 'CourseClassAbsenceRequestController@acceptAbsenceRequest');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-absence-request/:id/accept-absence-request',
    method: 'POST',
    schema: courseClassAbsenceRequestSchema,
    transform: createTransform(courseClassAbsenceRequestSchema, 'data'),
}
export const course_class_rejectAbsenceRequest_Api = {
    name: 'course_class_rejectAbsenceRequest_Api',
    backend: `Route::post('courses/course-class-absence-request/{id}/reject-absence-request', 'CourseClassAbsenceRequestController@rejectAbsenceRequest');`,
    root: API_ROOT_URL,
    path: '/courses/course-class-absence-request/:id/reject-absence-request',
    method: 'POST',
    schema: courseClassAbsenceRequestSchema,
    transform: createTransform(courseClassAbsenceRequestSchema, 'data'),
}

export const course_class_getAbsenceRequestsForDate_Api = {
    name: 'course_class_getAbsenceRequestsForDate_Api',
    backend: `Route::get('courses/course-class/{id}/absence-requests-for-date', 'CourseClassAbsenceRequestController@getAbsenceRequestsForDate');`,
    root: API_ROOT_URL,
    path: '/courses/course-class/:id/absence-requests-for-date',
    method: 'GET',
    paramsFields: ['attendance_date'],
}
